import React from 'react';

import { Info } from '@entities/info';

const InfoPage = () => {
	return <Info />;
};

export default InfoPage;
